/**Очередь в которой находится задача */
export class TaskQueueModel {
  /**Id очереди */
  Id?: string;
  /**Имя очереди */
  Name?: string;
  /**Id рабочей области */
  NamespaceId?: string;

  constructor(obj?: TaskQueueModel) {
    if (obj) Object.assign(this, obj);
  }
}
